import { Pencil } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { formatDistanceToNow } from 'date-fns';

interface EditedIndicatorProps {
  editedAt: string;
  className?: string;
}

export function EditedIndicator({ editedAt, className = '' }: EditedIndicatorProps) {
  const editedDate = new Date(editedAt);
  const timeAgo = formatDistanceToNow(editedDate, { addSuffix: true });

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`inline-flex items-center gap-1 text-xs text-muted-foreground ${className}`}>
            <Pencil className="w-3 h-3" />
            <span>Edited</span>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-xs">Last edited {timeAgo}</p>
          <p className="text-xs text-muted-foreground">
            {editedDate.toLocaleString()}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
